webpackJsonp([31],{

/***/ 1010:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Account; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectors__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_immutable_pure_component__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_immutable_pure_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_immutable_pure_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_immutable_proptypes__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_avatar__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_display_name__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_icon_button__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_intl__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_lists__ = __webpack_require__(96);





var _dec, _class, _class2, _temp;













var messages = Object(__WEBPACK_IMPORTED_MODULE_13_react_intl__["f" /* defineMessages */])({
  remove: {
    'id': 'lists.account.remove',
    'defaultMessage': 'Remove from list'
  },
  add: {
    'id': 'lists.account.add',
    'defaultMessage': 'Add to list'
  }
});

var makeMapStateToProps = function makeMapStateToProps() {
  var getAccount = Object(__WEBPACK_IMPORTED_MODULE_7__selectors__["c" /* makeGetAccount */])();

  var mapStateToProps = function mapStateToProps(state, _ref) {
    var accountId = _ref.accountId,
        added = _ref.added;
    return {
      account: getAccount(state, accountId),
      added: typeof added === 'undefined' ? state.getIn(['listEditor', 'accounts', 'items']).includes(accountId) : added
    };
  };

  return mapStateToProps;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
  var accountId = _ref2.accountId;
  return {
    onRemove: function onRemove() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_lists__["D" /* removeFromListEditor */])(accountId));
    },
    onAdd: function onAdd() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_lists__["v" /* addToListEditor */])(accountId));
    }
  };
};

var Account = (_dec = Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(makeMapStateToProps, mapDispatchToProps), _dec(_class = Object(__WEBPACK_IMPORTED_MODULE_13_react_intl__["g" /* injectIntl */])(_class = (_temp = _class2 = function (_ImmutablePureCompone) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Account, _ImmutablePureCompone);

  function Account() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Account);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _ImmutablePureCompone.apply(this, arguments));
  }

  Account.prototype.render = function render() {
    var _props = this.props,
        account = _props.account,
        intl = _props.intl,
        onRemove = _props.onRemove,
        onAdd = _props.onAdd,
        added = _props.added;


    var button = void 0;

    if (added) {
      button = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__components_icon_button__["a" /* default */], {
        icon: 'times',
        title: intl.formatMessage(messages.remove),
        onClick: onRemove
      });
    } else {
      button = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__components_icon_button__["a" /* default */], {
        icon: 'plus',
        title: intl.formatMessage(messages.add),
        onClick: onAdd
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'account'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'account__wrapper'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'account__display-name'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'account__avatar-wrapper'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__components_avatar__["a" /* default */], {
      account: account,
      size: 36
    })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__components_display_name__["a" /* default */], {
      account: account
    })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'account__relationship'
    }, void 0, button)));
  };

  return Account;
}(__WEBPACK_IMPORTED_MODULE_8_react_immutable_pure_component___default.a), _class2.propTypes = {
  account: __WEBPACK_IMPORTED_MODULE_9_react_immutable_proptypes___default.a.map.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
  onRemove: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  onAdd: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  added: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
}, _class2.defaultProps = {
  added: false
}, _temp)) || _class) || _class);


/***/ }),

/***/ 1011:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Search; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_lists__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);





var _dec, _class;








var messages = Object(__WEBPACK_IMPORTED_MODULE_6_react_intl__["f" /* defineMessages */])({
  search: {
    'id': 'lists.search',
    'defaultMessage': 'Search among people you follow'
  }
});

var mapStateToProps = function mapStateToProps(state) {
  return {
    value: state.getIn(['listEditor', 'suggestions', 'value'])
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSubmit: function onSubmit(value) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_lists__["B" /* fetchListSuggestions */])(value));
    },
    onClear: function onClear() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_lists__["y" /* clearListSuggestions */])());
    },
    onChange: function onChange(value) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_lists__["x" /* changeListSuggestions */])(value));
    }
  };
};

var Search = (_dec = Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps, mapDispatchToProps), _dec(_class = Object(__WEBPACK_IMPORTED_MODULE_6_react_intl__["g" /* injectIntl */])(_class = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Search, _React$PureComponent);

  function Search() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Search);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.handleChange = function (e) {
      _this.props.onChange(e.target.value);
    }, _this.handleKeyUp = function (e) {
      if (e.keyCode === 13) {
        _this.props.onSubmit(_this.props.value);
      }
    }, _this.handleClear = function () {
      _this.props.onClear();
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Search.prototype.render = function render() {
    var _props = this.props,
        value = _props.value,
        intl = _props.intl;

    var hasValue = value.length > 0;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'list-editor__search search'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('label', {}, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('span', {
      style: { display: 'none' }
    }, void 0, intl.formatMessage(messages.search)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('input', {
      className: 'search__input',
      type: 'text',
      value: value,
      onChange: this.handleChange,
      onKeyUp: this.handleKeyUp,
      placeholder: intl.formatMessage(messages.search)
    })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      role: 'button',
      tabIndex: '0',
      className: 'search__icon',
      onClick: this.handleClear
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('i', {
      className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('fa fa-search', { active: !hasValue })
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('i', {
      'aria-label': intl.formatMessage(messages.search),
      className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('fa fa-times-circle', { active: hasValue })
    })));
  };

  return Search;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.PureComponent)) || _class) || _class);


/***/ }),

/***/ 838:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ListEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_immutable_proptypes__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_immutable_pure_component__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_immutable_pure_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_immutable_pure_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_lists__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_account__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_search__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ui_util_optional_motion__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_motion_lib_spring__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_motion_lib_spring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_motion_lib_spring__);





var _dec, _class, _class2, _temp;













var mapStateToProps = function mapStateToProps(state) {
  return {
    title: state.getIn(['listEditor', 'title']),
    accountIds: state.getIn(['listEditor', 'accounts', 'items']),
    searchAccountIds: state.getIn(['listEditor', 'suggestions', 'items'])
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onInitialize: function onInitialize(listId) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_lists__["F" /* setupListEditor */])(listId));
    },
    onClear: function onClear() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_lists__["y" /* clearListSuggestions */])());
    },
    onReset: function onReset() {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_lists__["E" /* resetListEditor */])());
    }
  };
};

var ListEditor = (_dec = Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(mapStateToProps, mapDispatchToProps), _dec(_class = Object(__WEBPACK_IMPORTED_MODULE_9_react_intl__["g" /* injectIntl */])(_class = (_temp = _class2 = function (_ImmutablePureCompone) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ListEditor, _ImmutablePureCompone);

  function ListEditor() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ListEditor);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _ImmutablePureCompone.apply(this, arguments));
  }

  ListEditor.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        onInitialize = _props.onInitialize,
        listId = _props.listId;

    onInitialize(listId);
  };

  ListEditor.prototype.componentWillUnmount = function componentWillUnmount() {
    var onReset = this.props.onReset;

    onReset();
  };

  ListEditor.prototype.render = function render() {
    var _props2 = this.props,
        title = _props2.title,
        accountIds = _props2.accountIds,
        searchAccountIds = _props2.searchAccountIds,
        onClear = _props2.onClear;

    var showSearch = searchAccountIds.size > 0;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'modal-root__modal list-editor'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('h4', {}, void 0, title), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__components_search__["a" /* default */], {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'drawer__pager'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'drawer__inner list-editor__accounts'
    }, void 0, accountIds.map(function (accountId) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__components_account__["a" /* default */], {
        accountId: accountId,
        added: true
      }, accountId);
    })), showSearch && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      role: 'button',
      tabIndex: '-1',
      className: 'drawer__backdrop',
      onClick: onClear
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__ui_util_optional_motion__["a" /* default */], {
      defaultStyle: { x: -100 },
      style: { x: __WEBPACK_IMPORTED_MODULE_14_react_motion_lib_spring___default()(showSearch ? 0 : -100, { stiffness: 210, damping: 20 }) }
    }, void 0, function (_ref) {
      var x = _ref.x;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
        className: 'drawer__inner backdrop',
        style: { transform: x === 0 ? null : 'translateX(' + x + '%)', visibility: x === -100 ? 'hidden' : 'visible' }
      }, void 0, searchAccountIds.map(function (accountId) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__components_account__["a" /* default */], {
          accountId: accountId
        }, accountId);
      }));
    })));
  };

  return ListEditor;
}(__WEBPACK_IMPORTED_MODULE_8_react_immutable_pure_component___default.a), _class2.propTypes = {
  listId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,
  onClose: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
  onInitialize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  onClear: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  onReset: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,
  accountIds: __WEBPACK_IMPORTED_MODULE_6_react_immutable_proptypes___default.a.list.isRequired,
  searchAccountIds: __WEBPACK_IMPORTED_MODULE_6_react_immutable_proptypes___default.a.list.isRequired
}, _temp)) || _class) || _class);


/***/ })

});


// WEBPACK FOOTER //
// features/list_editor.js